import gql from 'graphql-tag';

export default gql`
  query netUoms {
    netUoms {
      nameLocal
      name
    }
  }
`;
